
export const colors = {
  // Primary Brand Colors
  primary: "#FF5F33",
  primaryLight: "#FF6B3D",
  primaryDark: "#E6451A",

  // Gradient
  gradient: "linear-gradient(90deg, #FF5F33, #FF6B3D, #FF8A5D)",

  // Light Theme Colors
  light: {
    background: "#F8F9FA", // Very light grey background
    foreground: "#1A1A1A", // Dark text for good contrast
    secondary: "#6C757D", // Medium grey for secondary text
    muted: "#E9ECEF", // Light grey for muted elements
    border: "#DEE2E6", // Light border color
    card: "#FFFFFF", // White cards
    input: "#FFFFFF", // White input backgrounds
    inputBorder: "#CED4DA", // Light grey input borders
    placeholder: "#6C757D", // Grey placeholder text
  },

  // Dark Theme Colors
  dark: {
    background: "#000000",
    foreground: "#FFFFFF",
    secondary: "#CCCCCC",
    muted: "#1A1A1A",
    border: "#333333",
    card: "#0A0A0A",
    input: "#1A1A1A", // Dark input backgrounds
    inputBorder: "#333333", // Dark input borders
    placeholder: "#999999", // Light grey placeholder text
  },

  // Common Colors
  accent: "#FF5F33",
  success: "#10B981",
  warning: "#F59E0B",
  error: "#EF4444",

  // Additional flamingo red variations for transitions
  accentLight: "#FF7D4D",
  accentDark: "#D63B0F",
  accentLighter: "#FF9F7D",
  accentDarker: "#B8330D",
};
